<a routerLink="/purposeful-days" (click)="purposefulDaysClicked.emit()">
  <div class="purposeful-days-indicator" [ngClass]="{ 'purposeful-day-fulfilled': complete }">
    <div class="purposeful-days-diamond" [ngClass]="{ 'purposeful-day-item-fulfilled': showedUp }">
      <div *ngIf="showedUp" class="purposeful-days-inner-diamond"></div>
    </div>
    <div class="bullet-separator"></div>
    <div class="purposeful-days-diamond" [ngClass]="{ 'purposeful-day-item-fulfilled': checkedIn }">
      <div *ngIf="checkedIn" class="purposeful-days-inner-diamond"></div>
    </div>
    <div class="bullet-separator"></div>
    <div class="purposeful-days-diamond" [ngClass]="{ 'purposeful-day-item-fulfilled': actionCompleted }">
      <div *ngIf="actionCompleted" class="purposeful-days-inner-diamond"></div>
    </div>
    <div class="bullet-separator" *ngIf="streakLength > 0"></div>
    <div class="purposeful-days-streak-flame" *ngIf="streakLength > 0">
      <svg-icon src="/assets/icons/streak-flame.svg"></svg-icon>
      <span class="streak-number">{{ streakLength }}</span>
    </div>
  </div>
</a>

<kui-modal
  *ngIf="showCelebrationModal"
  [isOpen]="showCelebrationModal"
  (isOpenChange)="isCelebrationModalOpen()"
  (click)="showCelebrationModal = false"
  [canDismiss]="false"
  type="info">
  <kp-modal-purposeful-days (closeClicked)="showCelebrationModal = false"></kp-modal-purposeful-days>
</kui-modal>
